<template>
  <v-sheet class="text-start">
    <page-head title="Topics" :breadcrumb="['Class', 'Topics']">
      <template v-slot>
        <v-btn variant="outlined" color="primary" :to="{ name: 'topicCreate' }"
          ><v-icon>mdi-plus</v-icon>Create Topic</v-btn
        >
      </template>
    </page-head>
    <v-data-table-server
      :items="dataTable.items"
      :items-per-page="dataTable.itemsPerPage"
      :items-length="dataTable.totalItems"
      :headers="dataTable.headers"
      :loading="dataTable.isLoading"
      :items-per-page-options="dataTable.itemsPerPageOptions"
      @update:options="updateTopic"
    >
      <template v-slot:[`item.name`]="{ value, item }">
        <a :href="`/management/topic/id-${item.id}`">{{ value }}</a></template
      ></v-data-table-server
    >
  </v-sheet>
</template>

<script setup>
import PageHead from "@/components/admin_theme/PageHead.vue";
import { reactive } from "vue";
import { authAxios } from "@/util/Axios";
import { DEFAULT_DATATABLE } from "@/util/List";

const axios = authAxios();
const dataTable = reactive({
  headers: [
    { title: "Name", key: "name", align: "start", sortable: false },
    { title: "Period", key: "period", align: "center", sortable: false },
    {
      title: "Max P.",
      key: "max_participant",
      align: "center",
      sortable: false,
    },
    {
      title: "Linked Fund",
      key: "linked_member_fund_name",
      align: "start",
      sortable: false,
    },
    { title: "Private", key: "is_private", align: "center", sortable: false },
  ],
  ...DEFAULT_DATATABLE,
});

function updateTopic({ page, itemsPerPage }) {
  dataTable.isLoading = true;
  loadTopic(page, itemsPerPage).then((response) => {
    dataTable.isLoading = false;
    dataTable.items = [...response.data.data];
    dataTable.totalItems = response.data.total_items;
  });
}

function loadTopic(page, length) {
  return axios({
    method: "GET",
    url: `${process.env.VUE_APP_BACKEND_URL}/api/topic/vuetify`,
    params: { page: page, length: length, search: "" },
  });
}
</script>
